/* eslint-disable import/prefer-default-export */
const SET_MEDICAL_AND_LIFESTYLE_V2 = "SET_MEDICAL_AND_LIFESTYLE_V2";
const SAVE_MEDICAL_AND_LIFESTYLE_V2 = "SAVE_MEDICAL_AND_LIFESTYLE_V2";

export { SET_MEDICAL_AND_LIFESTYLE_V2, SAVE_MEDICAL_AND_LIFESTYLE_V2 };
